import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-text-mark-menu',
  templateUrl: './text-mark-menu.component.html',
  styleUrls: ['./text-mark-menu.component.css']
})
export class TextMarkMenuComponent implements OnInit {
  // 任务id
  @Input() taskId: string = '';
  @Input() contentList: any = [];
  // 选中图片后：抛出事件
  @Output() toCurrentPage = new EventEmitter();
  pageBase:any = {
    current: 1,
    size: 1,
    pages: 1,
    total: 1
  }
  // 当前查看的图像路径 
  imgPath:string = '';
  // 当前输入的页码
  inputPageNum: any = null;
  constructor(
    private kmsService: KmsService,
    private message: SwMassageBoxService,
  ) { }

  ngOnInit() {
    
  }

  ngOnChanges(){
    if(this.contentList.length>0){
      this.pageBase.total = this.contentList.length;
      this.getData();
    }
  }

  // 分页查询
  getData(){
    const img = this.contentList[this.pageBase.current-1];
    if(img.filePath){
      this.imgPath = img.filePath;
    }else{
      this.imgPath = '';
    }
    this.toPage(this.pageBase.current-1);
  }

  // 跳转到上一页
  toPrevPage() {
    if (this.pageBase.current == 1) {
      return;
    }
    this.pageBase.current--;
    this.getData();
  }

  // 跳转到下一页
  toNextPage() {
    if (this.pageBase.current == this.pageBase.total) {
        return;
    }
    this.pageBase.current++;
    this.getData();
  }

  // 点击确定按钮跳转某一页
  clickSure() {
    if (this.inputPageNum == this.pageBase.current) {
        return;
    }
    const reg = /^[1-9]\d*$/;
    if (this.inputPageNum && reg.test(this.inputPageNum)) {
        if (this.inputPageNum > this.pageBase.total) {
            this.message.info("输入值大于总页数！");
            return;
        }
        this.pageBase.current = this.inputPageNum;
        this.getData();
    } else {
        this.message.info('请输入一个大于0的整数！');
    }
  }

  // 跳转到某一页
  toPage(pageNum){
    this.toCurrentPage.emit(pageNum);
  }

}
